import { render, staticRenderFns } from "./DomainData.vue?vue&type=template&id=2afc8d48&scoped=true&"
import script from "./DomainData.vue?vue&type=script&lang=js&"
export * from "./DomainData.vue?vue&type=script&lang=js&"
import style0 from "./DomainData.vue?vue&type=style&index=0&id=2afc8d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc8d48",
  null
  
)

export default component.exports